import {
  ACTIVITY_CENTER_FROM_LOGIN_FLAG,
  LANG_LOCAL_STORAGE_KEY,
  UrsOptions,
  rbacUrsCheck,
  setNeteaseCookieDomain,
} from '@yaotai/common-utils';
import { getUrsCookieDomain, getYaotaiRbacCookieDomain } from '@commonPackage/utils';
import { DEFAULT_LOGIN_TARGE_PATH } from '@/constants';

export const portalPcCommonUrsOptions: UrsOptions = {
  regcb: username => {
    setNeteaseCookieDomain(getYaotaiRbacCookieDomain());
    rbacUrsCheck({
      url: DEFAULT_LOGIN_TARGE_PATH,
      username,
      rbac_server: import.meta.env.VITE_RBAC_SERVER!,
    });
    localStorage.setItem(ACTIVITY_CENTER_FROM_LOGIN_FLAG, 'true');
  },
  logincb: username => {
    setNeteaseCookieDomain(getYaotaiRbacCookieDomain());
    rbacUrsCheck({
      url: DEFAULT_LOGIN_TARGE_PATH,
      username,
      rbac_server: import.meta.env.VITE_RBAC_SERVER!,
    });
    localStorage.setItem(ACTIVITY_CENTER_FROM_LOGIN_FLAG, 'true');
  },
  cssDomain: window.location.origin,
  cssFiles: `/custom-login-${localStorage.getItem(LANG_LOCAL_STORAGE_KEY)?.includes('en') ? 'en' : 'zh'}.css`,
  cookieDomain: getUrsCookieDomain()!,
  regCookieDomain: getUrsCookieDomain()!,
};

export const getPortalPcUrsOptions = (options: Partial<UrsOptions> = {}) => {
  return {
    ...portalPcCommonUrsOptions,
    ...options,
  };
};
